// FIXME: This file is just an example, please take it as reference to make your own.

const routes = {
  authCallback: '/auth/callback',
  root: '/'
}

export default routes
